<template>
  <v-app>
    <v-container fluid>
      <v-row
        ><v-col cols="12">
          <v-expansion-panels v-model="panel"
            ><v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text
                ><v-form @submit.prevent="submit"
                  ><v-row class="pa-2">
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        v-model="product_id.value.value"
                        label="Product"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="getProductList"
                        :item-title="
                          (item) => `${item.code}-${item.name}` ?? 'N/A'
                        "
                        item-value="id"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-autocomplete
                        v-model="category_id.value.value"
                        label="Category"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="getCategoryList"
                        item-title="name"
                        item-value="id"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        v-model="subcategory_id.value.value"
                        label="Sub Category"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="getSubCategoryList"
                        item-title="name"
                        item-value="id"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-autocomplete
                        v-model="brand_id.value.value"
                        label="Brand"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="getBrandList"
                        item-title="name"
                        item-value="id"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        v-model="product_type_id.value.value"
                        label="Product Type"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="getProductTypeList"
                        item-title="name"
                        item-value="id"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-select
                        v-model="status.value.value"
                        label="Status"
                        bg-color="grey-lighten-4"
                        variant="outlined"
                        density="compact"
                        :items="statusOptions"
                        item-title="title"
                        item-value="value"
                        clearable
                        hide-details
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12" class="d-flex align-end"
                      ><v-btn
                        class="bg-brand my-1"
                        type="submit"
                        :loading="loading"
                        >Search</v-btn
                      ></v-col
                    >
                  </v-row></v-form
                ></v-expansion-panel-text
              >
            </v-expansion-panel></v-expansion-panels
          >
        </v-col></v-row
      >
    </v-container>

    <v-container fluid style="margin-top: -20px"
      ><v-row
        ><v-col cols="12">
          <v-expansion-panels v-model="panel"
            ><v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Items List</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12"
                    ><v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      hide-details
                      density="compact"
                      variant="outlined"
                      clearable
                  /></v-col>
                  <v-col md="4" cols="12" class="d-flex justify-center"
                    ><v-btn-group
                      variant="outlined"
                      density="compact"
                      size="x-small"
                      divided
                    >
                      <v-btn
                        prepend-icon="mdi mdi-download"
                        variant="flat"
                        color="success"
                        @click="exportToCSV"
                        >CSV</v-btn
                      >
                      <v-btn
                        prepend-icon="mdi mdi-download"
                        variant="flat"
                        color="primary"
                        @click="exportToExcel"
                        >EXCEL</v-btn
                      >
                      <v-btn
                        prepend-icon="mdi mdi-download"
                        variant="flat"
                        color="red"
                        @click="exportToPDF"
                        >PDF</v-btn
                      >
                    </v-btn-group></v-col
                  >
                </v-row>
                <v-data-table
                  :headers="reportHeaders"
                  :items="reports?.data || []"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  hover
                  density="compact"
                >
                  <template #item.reorder_level="{ item }">{{
                    formatNumber(item.reorder_level)
                  }}</template>
                  <template #item.minimum_stock="{ item }">{{
                    formatNumber(item.minimum_stock)
                  }}</template>
                  <template #item.maximum_stock="{ item }">{{
                    formatNumber(item.maximum_stock)
                  }}</template>
                  <template #item.purchase_price="{ item }">{{
                    formatNumber(item.purchase_price)
                  }}</template>
                  <template #item.issue_sales_price="{ item }">{{
                    formatNumber(item.issue_sales_price)
                  }}</template>
                  <template #item.tax_vat_rate="{ item }">{{
                    formatNumber(item.tax_vat_rate)
                  }}</template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel></v-expansion-panels
          >
        </v-col></v-row
      ></v-container
    >
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    statusOptions: [
      { title: "Active", value: 1 },
      { title: "Inactive", value: 0 },
    ],
    headers: [
      { title: "SL", key: "sl", align: "center", sortable: false },
      { title: "Item Code", key: "item_code", align: "left", sortable: false },
      { title: "Item Name", key: "item_name", align: "left", sortable: false },
      {
        title: "Short Name",
        key: "short_name",
        align: "left",
        sortable: false,
      },
      { title: "Category", key: "category", align: "left", sortable: false },
      {
        title: "Subcategory",
        key: "subcategory",
        align: "left",
        sortable: false,
      },
      { title: "Brand", key: "brand", align: "left", sortable: false },
      {
        title: "Specification",
        key: "specification",
        align: "left",
        sortable: false,
      },
      { title: "UOM", key: "uom", align: "left", sortable: false },
      { title: "Item Type", key: "item_type", align: "left", sortable: false },
      {
        title: "Reorder Level",
        key: "reorder_level",
        align: "end",
        sortable: false,
      },
      {
        title: "Minimum Stock",
        key: "minimum_stock",
        align: "end",
        sortable: false,
      },
      {
        title: "Maximum Stock",
        key: "maximum_stock",
        align: "end",
        sortable: false,
      },
      {
        title: "Default Warehouse",
        key: "default_warehouse",
        align: "left",
        sortable: false,
      },
      {
        title: "Purchase Price",
        key: "purchase_price",
        align: "end",
        sortable: false,
      },
      {
        title: "Issue/Sales Price",
        key: "issue_sales_price",
        align: "end",
        sortable: false,
      },
      {
        title: "Tax/VAT Rate",
        key: "tax_vat_rate",
        align: "end",
        sortable: false,
      },
      {
        title: "Expiry Applicable",
        key: "expiry_applicable",
        align: "left",
        sortable: false,
      },
      {
        title: "Active Status",
        key: "active_status",
        align: "left",
        sortable: false,
      },
      {
        title: "Created Date",
        key: "created_date",
        align: "left",
        sortable: false,
      },
    ],
  }),
  computed: {
    reportHeaders() {
      const columns = this.reports?.columns;
      if (!Array.isArray(columns) || !columns.length) return this.headers;
      return columns.map(({ field, label }) => ({ title: label, key: field, align: field === "sl" ? "center" : "start", sortable: false }));
    },
    getProductList() {
      return (this.$store.getters.getProductList || []).filter(
        (item) => item.status == 1,
      );
    },
    getCategoryList() {
      return (this.$store.getters.getCategoryList || []).filter(
        (item) => item.status == 1,
      );
    },
    getSubCategoryList() {
      return (this.$store.getters.getSubCategoryList || []).filter(
        (item) => item.status == 1,
      );
    },
    getBrandList() {
      return (this.$store.getters.getBrandList || []).filter(
        (item) => item.status == 1,
      );
    },
    getProductTypeList() {
      return (this.$store.getters.getProductTypeList || []).filter(
        (item) => item.status == 1,
      );
    },
  },
  created() {
    if (this.getProductList.length === 0)
      this.$store.dispatch("getProductList");
    if (this.getCategoryList.length === 0)
      this.$store.dispatch("getCategoryList");
    if (this.getSubCategoryList.length === 0)
      this.$store.dispatch("getSubCategoryList");
    if (this.getBrandList.length === 0) this.$store.dispatch("getBrandList");
    if (this.getProductTypeList.length === 0)
      this.$store.dispatch("getProductTypeList");
  },
  setup() {
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });
    const product_id = useField("product_id"),
      category_id = useField("category_id");
    const subcategory_id = useField("subcategory_id"),
      brand_id = useField("brand_id");
    const product_type_id = useField("product_type_id"),
      status = useField("status");
    const store = useStore(),
      loading = ref(false),
      reports = ref({});
    const submit = handleSubmit((values) => {
      loading.value = true;
      store
        .dispatch("getInvItemsReport", values)
        .then((response) => {
          reports.value = response.data;
        })
        .catch((error) =>
          toast.error(error.response?.data?.message || "Unable to load report"),
        )
        .finally(() => {
          loading.value = false;
        });
    });
    return {
      product_id,
      category_id,
      subcategory_id,
      brand_id,
      product_type_id,
      status,
      loading,
      reports,
      submit,
    };
  },
  methods: {
    formatNumber(value) {
      return value == null ? "" : Number(value).toFixed(2);
    },
    exportRows() {
      return [
        this.reportHeaders.map((header) => header.title),
        ...(this.reports?.data || []).map((item) =>
          this.reportHeaders.map((header) => item[header.key] ?? ""),
        ),
      ];
    },
    exportToCSV() {
      this.$exportTableToCSV(
        this.exportRows(),
        `items_list_${this.$fileDate()}`,
      );
    },
    exportToExcel() {
      this.$exportTableToExcel(
        this.exportRows(),
        `items_list_${this.$fileDate()}`,
      );
    },
    exportToPDF() {
      this.$exportTableToPDF(
        this.reportHeaders.map((header) => header.title),
        (this.reports?.data || []).map((item) =>
          this.reportHeaders.map((header) => item[header.key] ?? ""),
        ),
        "Items List",
        `items_list_${this.$fileDate()}`,
      );
    },
  },
};
</script>
